import { useEffect, useState } from 'react';

import { DontExistsItem } from '../../../components/DontExistsItem';
import { DontExistsItemFlex } from '../../../components/DontExistsItem/styles';
import { ListCardsScheduledCollect } from '../../../components/List/Collects/ListCardsScheduledCollect';
import { ListScheduleCollects } from '../../../components/List/ListScheduleCollects';
import { LoadingData } from '../../../components/LoadingData';
import { InfoScheduledCollect } from '../../../components/Modal/InfoScheduledCollect';
import { PageHeader, ViewMode } from '../../../components/PageHeader';
import { Paginator } from '../../../components/Paginator';
import { useScheduleContext } from '../../../context/ProviderPage/Programacao';
import { usePageContext } from '../../../context/usePage';
import { ContainerPage, PageContent } from '../../../styles/global.styles';

const Programacao = () => {
  const { setSelectedPage } = usePageContext();
  const [modifyViewMode, setModifyViewMode] = useState<ViewMode>({
    have: true,
    mode: 'card',
  });
  const {
    loadingScheduleCollect,
    loadScheduleAction,
    scheduleCollect,
    openSideModalFilterScheduleCollectAction,
    openInfo,
    setOpenInfo,
    setOfsset,
    limit,
    offset,
    quantity,
    page,
    setPage,
    setHasClick,
    start,
    setStart,
  } = useScheduleContext();

  useEffect(() => {
    setSelectedPage({ option: 'programacao' });
    loadScheduleAction();
  }, []);

  return (
    <>
      <PageHeader
        {...{
          pageIcon: { option: 'programacao' },
          pageTitle: 'Programação',
          filterAction: openSideModalFilterScheduleCollectAction,
          modifyViewMode,
          setModifyViewMode,
        }}
      />

      <ContainerPage>
        <PageContent
          style={{
            justifyContent: `${
              loadingScheduleCollect === true ? 'center' : 'space-between'
            }`,
          }}
        >
          {loadingScheduleCollect ? (
            <LoadingData title="Buscando dados" />
          ) : (
            <>
              {scheduleCollect.length === 0 ? (
                <DontExistsItemFlex>
                  <DontExistsItem title="Nenhuma programação foi encontrada!" />
                </DontExistsItemFlex>
              ) : (
                <>
                  {modifyViewMode.mode === 'normal' ? (
                    <ListScheduleCollects data={scheduleCollect} />
                  ) : (
                    <ListCardsScheduledCollect data={scheduleCollect} />
                  )}

                  <Paginator
                    {...{
                      start,
                      setStart,
                      limitItens: limit,
                      offset,
                      page,
                      quantity,
                      setHasClick,
                      setOfsset,
                      setPage,
                      quantityShowed: scheduleCollect.length,
                    }}
                  />
                </>
              )}
            </>
          )}
        </PageContent>
        <InfoScheduledCollect
          option="programacao"
          titleModal="Programação selecionada"
          isOpen={openInfo}
          closeModal={setOpenInfo}
        />
      </ContainerPage>
    </>
  );
};

export { Programacao };
